import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_address,
  get_address_success,
  get_address_error,
  create_address,
  create_address_success,
  create_address_error,
  update_address,
  update_address_success,
  update_address_error,
  delete_address,
  delete_address_success,
  delete_address_error,
  pay_for_basket,
  pay_for_basket_success,
  pay_for_basket_error,
} from './reducer';

import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getAddress() {
  try {
    const requestRes = yield call(api.get, `/addresses`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_address_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_address_error.type,
    });
  }
}

function* createAddress({ payload }) {
  try {
    const requestRes = yield call(api.post, `/addresses`, payload);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: create_address_success.type,
      payload: response,
    });
    toast.success(responseData?.message);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: create_address_error.type,
    });
  }
}

function* deleteAddress({ payload }) {
  try {
    const requestRes = yield call(api.delete, `/addresses/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: delete_address_success.type,
      payload: response,
    });
    toast.success('Address has been deleted successfully!');
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: delete_address_error.type,
    });
  }
}

function* updateAddress({ payload }) {
  try {
    const { id, data } = payload;
    const requestRes = yield call(api.put, `/addresses/${id}`, data);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: update_address_success.type,
      payload: response,
    });
    toast.success('Address has been updated successfully!');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: update_address_error.type,
    });
  }
}

function* payForBasketSagas({ payload }) {
  try {
    const res = yield call(api.post, `/payments`, payload);
    const responseData = res.data;
    yield put({
      type: pay_for_basket_success.type,
      payload: responseData,
    });
    toast.success('Order has been successfully placed!!');
    setTimeout(() => {
      localStorage.removeItem('loggedInCart');
      window.location.href = `/order/success/${responseData.data.order}`;
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: pay_for_basket_error.type,
    });
  }
}

function* groupDetailsSagas() {
  yield takeEvery(get_address.type, getAddress);
  yield takeEvery(create_address.type, createAddress);
  yield takeEvery(delete_address.type, deleteAddress);
  yield takeEvery(update_address.type, updateAddress);
  yield takeEvery(pay_for_basket.type, payForBasketSagas);
}

export default groupDetailsSagas;
